import React from 'react';

export const CloseOutlined = ({ color = '#4B4F5E' }) => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.26659 9.66634L0.333252 8.73301L4.06659 4.99967L0.333252 1.26634L1.26659 0.333008L4.99992 4.06634L8.73325 0.333008L9.66659 1.26634L5.93325 4.99967L9.66659 8.73301L8.73325 9.66634L4.99992 5.93301L1.26659 9.66634Z" fill={color} />
  </svg>
);